<template>
    <div :class="{ rootOffline: isOffline }" class="root-component">
        <div class="flex flex-col min-h-main items-center justify-center" v-if="!dataLoaded">
            <div class="flex flex-col items-center mb-10" style="width: 12rem">
                <img src="/logoTex.svg" alt="TEX logo" class="mb-1" />
            </div>
            {{ $t('project.loading') }}
            <icon-rotate-right class="animate animate-spin"></icon-rotate-right>
        </div>
        <template v-else>
            <ToolBar
                class="fixed top-0 w-full z-40"
                :isOpen="isOpen"
                v-on:toggle-menu="onToggleMenu"
                v-if="!$route.query.noToolBar"
            >
                <template v-slot:breadCrumbRoot>
                    <router-link
                        class="mx-2 hidden md:flex"
                        :to="{ name: 'home' }"
                        :aria-label="$t('home.title')"
                        v-if="$route.name !== 'home'"
                    >
                        <img src="/logoTex_white.svg" style="width: 60px" alt="TEX Logo" />
                    </router-link>
                    <div v-else>
                        <img src="/logoTex_white.svg" style="width: 60px" alt="TEX Logo" />
                    </div>
                </template>
            </ToolBar>
            <div
                class="flex"
                :class="{
                    'aside-opened': isOpen && $route.meta.hideMenu !== true,
                    'aside-closed': !isOpen || $route.meta.hideMenu === true,
                }"
            >
                <router-view
                    name="aside"
                    class="fixed min-h-main"
                    :class="{ 'mt-toolbar': !$route.query.noToolBar }"
                ></router-view>
                <router-view
                    class="left-w-full left-aside items-center flex flex-col"
                    :class="{ 'mt-toolbar': !$route.query.noToolBar }"
                ></router-view>
            </div>
            <dialogs-wrapper></dialogs-wrapper>
        </template>
    </div>
</template>

<script>
import ToolBar from '../components/ToolBar.vue';
import Menu from '../components/MainMenu.vue';
import { getMenuState, networkStatus, updateMenuState } from '@/state/state';
import database, { initProjectCollections, isReadyProject } from '@/rxdb/database';
import { queryProject } from '@/features/projects/projects.service';

export default {
    components: { ToolBar, Menu },
    created() {
        this.subscriptions = [
            getMenuState((menuState) => (this.isOpen = menuState.isOpen)),
            networkStatus.subscribe((isOnline) => (this.isOffline = !isOnline)),
        ];
        return this.init(true);
    },
    methods: {
        async replicate(projectId, routeName) {
            if (routeName && (routeName.includes('print') || routeName.includes('Print'))) {
                await database.replicateProject(projectId);
            } else {
                database.replicateProject(projectId).catch((err) => console.error(err));
            }
        },
        async init(isOnCreate) {
            const projectId = this.$route.params.projectId;
            this.currentProjectId = projectId;
            const isNewProject = projectId && !isReadyProject(projectId);
            if (isOnCreate || isNewProject) {
                this.lock();
            }
            await database.initDb;
            if (projectId) {
                if (isNewProject) {
                    await initProjectCollections(projectId);
                }
                await this.replicate(projectId, this.$route.name);
            }
            this.unlock();
        },
        // an unselected project is only replicated while it is open
        async releaseProject(projectId) {
            const project = await queryProject(projectId);
            if (project && !project.isSynchronized) {
                await database.removeProjectCollections(projectId);
            }
        },
        lock() {
            this.dataLoaded = false;
            document.body.classList.add('loading');
        },
        unlock() {
            document.body.classList.remove('loading');
            this.dataLoaded = true;
        },
        onToggleMenu: async function () {
            this.isOpen = !this.isOpen;
            updateMenuState({ isOpen: this.isOpen });
        },
    },
    destroyed() {
        if (this.currentProjectId) {
            this.releaseProject(this.currentProjectId).catch((err) => console.error(err));
        }
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.params.projectId && newRoute.params.projectId !== oldRoute.params.projectId) {
                const previousProjectId = oldRoute.params.projectId;
                if (previousProjectId) {
                    this.$nextTick(() => this.releaseProject(previousProjectId).catch((err) => console.error(err)));
                }
                return this.init(false);
            }
        },
    },
    data() {
        return {
            dataLoaded: false,
            isOpen: true,
            isOffline: !navigator.onLine,
            subscriptions: [],
            currentProjectId: null,
        };
    },
};
</script>
